import { getBriefComponentById } from 'modules/quotes/quoteItemComponents/data/reducer';
import { PURCHASED_COMPONENT_ADD_SUCCESS } from 'modules/quotes/quoteItems/data/types';

import { PAGE_REQUEST } from 'store/app/types';

import { types } from './actions';
import { MODES, TABS } from './constants';

const initialState = {
  activeTab: TABS.SMART_MATCHES,
  componentId: null,
  isConvertingComponent: false,
  isOpen: false,
  isFetchingSmartMatches: false,
  mode: MODES.CONVERT,
  overrideSearchTerm: '',
  quoteItemId: null,
  smartMatchSelectedProductId: null,
  smartMatchSelectedPurchasedComponentId: null,
  smartMatchSelectedPurchasedComponentHasProduct: false,
  smartProductMatches: [],
  smartPurchasedComponentMatches: [],
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case PAGE_REQUEST:
    case PURCHASED_COMPONENT_ADD_SUCCESS:
      return initialState;
    case types.CLOSE:
      return {
        ...state,
        componentId: null,
        isOpen: false,
      };
    case types.FETCH_SMART_MATCHES_ERROR:
      return {
        ...state,
        isFetchingSmartMatches: false,
      };
    case types.FETCH_SMART_MATCHES_REQUEST:
      return {
        ...state,
        isFetchingSmartMatches: true,
        smartProductMatches: [],
        smartPurchasedComponentMatches: [],
      };
    case types.FETCH_SMART_MATCHES_SUCCESS:
      return {
        ...state,
        isFetchingSmartMatches: false,
        smartProductMatches: payload.products,
        smartPurchasedComponentMatches: payload.purchasedComponents,
      };
    case types.OPEN:
      return {
        ...initialState,
        componentId: payload.componentId,
        isOpen: true,
        mode: payload.mode,
        quoteItemId: payload.quoteItemId,
      };
    case types.SAVE_COMPONENT_AND_LINK_PRODUCT:
      return {
        ...state,
        isConvertingComponent: true,
      };
    case types.SAVE_COMPONENT_ERROR:
      return {
        ...state,
        isConvertingComponent: false,
      };
    case types.SAVE_COMPONENT_REQUEST:
      return {
        ...state,
        isConvertingComponent: true,
      };
    case types.SAVE_COMPONENT_SUCCESS:
      return {
        ...state,
        isConvertingComponent: false,
        isOpen: false,
      };
    case types.SEARCH_SET_OVERRIDE_SEARCH_TERM:
      return {
        ...state,
        overrideSearchTerm: payload.overrideSearchTerm,
      };
    case types.SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: payload.tab,
      };
    case types.SMART_MATCH_SELECT_PRODUCT:
      return {
        ...state,
        smartMatchSelectedProductId: payload.productId,
        smartMatchSelectedPurchasedComponentId: null,
        smartMatchSelectedPurchasedComponentHasProduct: false,
      };
    case types.SMART_MATCH_SELECT_PURCHASED_COMPONENT:
      return {
        ...state,
        smartMatchSelectedProductId: null,
        smartMatchSelectedPurchasedComponentId: payload.purchasedComponentId,
        smartMatchSelectedPurchasedComponentHasProduct: payload.hasProduct,
      };
    default:
      return state;
  }
};

const getScope = (state) =>
  state.modules.quotes.quoteItemComponents.purchasedComponentsDrawer;

export const getActiveTab = (state) => getScope(state).activeTab;

export const getIsOpen = (state) => getScope(state).isOpen;

export const getComponentId = (state) => getScope(state).componentId;

export const getComponent = (state) => {
  const componentId = getComponentId(state);
  return getBriefComponentById(state, componentId);
};

export const getIsConvertingComponent = (state) =>
  getScope(state).isConvertingComponent;

export const getIsFetchingSmartMatches = (state) =>
  getScope(state).isFetchingSmartMatches;

export const getMode = (state) => getScope(state).mode;

export const getOverrideSearchTerm = (state) =>
  getScope(state).overrideSearchTerm;

export const getQuoteItemId = (state) => getScope(state).quoteItemId;

export const getSmartMatchSelectedProductId = (state) =>
  getScope(state).smartMatchSelectedProductId;

export const getSmartMatchSelectedPurchasedComponentId = (state) =>
  getScope(state).smartMatchSelectedPurchasedComponentId;

export const getSmartMatchSelectedPurchasedComponentHasProduct = (state) =>
  getScope(state).smartMatchSelectedPurchasedComponentHasProduct;

export const getSmartProductMatches = (state) =>
  getScope(state).smartProductMatches;

export const getSmartPurchasedComponentMatches = (state) =>
  getScope(state).smartPurchasedComponentMatches;

export const getSelectedPurchasedComponentHasProduct = (state) => {
  const activeTab = getActiveTab(state);
  if (activeTab === TABS.SMART_MATCHES) {
    return getSmartMatchSelectedPurchasedComponentHasProduct(state);
  }
  return false;
};

export default reducer;
